import { render, staticRenderFns } from "./CreateLokasi.vue?vue&type=template&id=e206b150&scoped=true"
import script from "./CreateLokasi.vue?vue&type=script&lang=js"
export * from "./CreateLokasi.vue?vue&type=script&lang=js"
import style0 from "./CreateLokasi.vue?vue&type=style&index=0&id=e206b150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e206b150",
  null
  
)

export default component.exports